import { render, staticRenderFns } from "./ProductFormatSelector.vue?vue&type=template&id=7c234c04&"
import script from "./ProductFormatSelector.vue?vue&type=script&lang=js&"
export * from "./ProductFormatSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports